import React, { useState, useEffect } from 'react';

const LoanPortfolio = ({ loanId }) => {
  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedDate, setSelectedDate] = useState('');
  const [tempDate, setTempDate] = useState('');

  // Get today's date in DD-MM-YYYY format
  const getTodayInDDMMYYYY = () => {
    const today = new Date();
    return formatDateToDDMMYYYY(today);
  };

  // Get today's date in YYYY-MM-DD format for input
  const getTodayForInput = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  };

  // Convert Date object to DD-MM-YYYY
  const formatDateToDDMMYYYY = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Convert YYYY-MM-DD to DD-MM-YYYY
  const convertInputDateToDDMMYYYY = (inputDate) => {
    if (!inputDate) return '';
    const dateObj = new Date(inputDate);
    return formatDateToDDMMYYYY(dateObj);
  };

  // Safe number parsing
  const safeNumber = (val) => (isNaN(parseFloat(val)) ? 0 : parseFloat(val));

  // Fetch data from API
  const fetchLoanData = async (calculationDate) => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(
        `https://wogombackend.infitouch.in/getDailyAmountToPay/${loanId}?calculationDate=${calculationDate}`
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      // Handle both single object and array responses
      const dataArray = Array.isArray(data) ? data : [data];
      setAllData(dataArray);

    } catch (err) {
      setError(err.message);
      console.error('Error fetching loan data:', err);
    } finally {
      setLoading(false);
    }
  };

  // Initialize component with today's date
  useEffect(() => {
    const today = getTodayForInput();
    const todayDDMMYYYY = getTodayInDDMMYYYY();

    setSelectedDate(today);
    setTempDate(today);
    fetchLoanData(todayDDMMYYYY);
  }, [loanId]);

  // Handle apply filter
  const handleApplyFilter = () => {
    if (!tempDate) return;

    setSelectedDate(tempDate);
    const calculationDate = convertInputDateToDDMMYYYY(tempDate);
    fetchLoanData(calculationDate);
  };

  // Clear filters and reset to today
  const clearFilters = () => {
    const today = getTodayForInput();
    const todayDDMMYYYY = getTodayInDDMMYYYY();

    setSelectedDate(today);
    setTempDate(today);
    fetchLoanData(todayDDMMYYYY);
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 2
    }).format(safeNumber(amount));
  };

  const getStatusBadgeClass = (status) => {
    if (!status) return 'p-2 rounded bg-secondary';
    switch (status.toLowerCase()) {
      case 'pending':
        return 'p-2 rounded bg-warning text-dark';
      case 'disbursed':
        return 'p-2 rounded bg-success';
      case 'overdue':
        return 'p-2 rounded bg-danger';
      default:
        return 'p-2 rounded bg-secondary';
    }
  };

  const getStatusIcon = (status) => {
    if (!status) return 'fa fa-clock-o';
    switch (status.toLowerCase()) {
      case 'pending':
        return 'fa fa-clock-o';
      case 'disbursed':
        return 'fa fa-check-circle';
      case 'overdue':
        return 'fa fa-exclamation-triangle';
      default:
        return 'fa fa-clock-o';
    }
  };

  return (
    <>
{/*
      <style>
        {`
          :root {
            --main-theme: #0c3953;
            --main-theme-light: rgba(12, 57, 83, 0.1);
            --main-theme-dark: #082a3a;
          }
          body {
            background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
            min-height: 100vh;
          }
          .main-theme-bg { background-color: var(--main-theme) !important; }
          .main-theme-text { color: var(--main-theme) !important; }
          .card-custom {
            border: none;
            border-radius: 20px;
            box-shadow: 0 10px 30px rgba(0,0,0,0.1);
            transition: all 0.3s ease;
            overflow: hidden;
          }
          .card-custom:hover {
            transform: translateY(-5px);
            box-shadow: 0 20px 40px rgba(0,0,0,0.15);
          }
        `}
      </style>
*/}
  <style>
        {`
          :root {
            --main-theme: #0c3953;
            --main-theme-light: rgba(12, 57, 83, 0.1);
            --main-theme-dark: #082a3a;
          }
          
          body {
            background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
            min-height: 100vh;
          }
          
          .main-theme-bg {
            background-color: var(--main-theme) !important;
          }
          
          .main-theme-text {
            color: var(--main-theme) !important;
          }
          
          .main-theme-light-bg {
            background-color: var(--main-theme-light) !important;
          }
          
          .card-custom {
            border: none;
            border-radius: 20px;
            box-shadow: 0 10px 30px rgba(0,0,0,0.1);
            transition: all 0.3s ease;
            overflow: hidden;
          }
          
          .card-custom:hover {
            transform: translateY(-5px);
            box-shadow: 0 20px 40px rgba(0,0,0,0.15);
          }
          
          .stat-card {
            border: none;
            border-radius: 16px;
            background: white;
            box-shadow: 0 4px 20px rgba(0,0,0,0.08);
            transition: all 0.3s ease;
          }
          
          .stat-card:hover {
            box-shadow: 0 8px 25px rgba(0,0,0,0.12);
          }
          
          .icon-circle {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.5rem;
          }
          
          .loan-header {
            background: linear-gradient(135deg, var(--main-theme) 0%, var(--main-theme-dark) 100%);
            color: white;
            border-radius: 20px 20px 0 0;
          }
          
          .amount-section {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            border-radius: 16px;
          }
          
          .detail-card {
            border-radius: 12px;
            border: 1px solid #dee2e6;
            transition: all 0.3s ease;
          }
          
          .detail-card:hover {
            border-color: var(--main-theme);
            box-shadow: 0 4px 12px rgba(12, 57, 83, 0.15);
          }
          
          .progress-custom {
            height: 8px;
            border-radius: 10px;
          }
          
          .fade-in {
            animation: fadeInUp 0.6s ease forwards;
          }
          
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
      <div className="container-fluid py-4 px-3 px-md-5">
        {/* Header Section */}
        <div className="row mb-4 fade-in">
          <div className="col-12">
            <div className=" mb-3" style={{display:'flex',alignItems:'center',gap:'5px'}}>
              <div className="icon-circle main-theme-bg text-white me-3">
                <i className="fa fa-credit-card"></i>
              </div>
              <div>
                <h1 className="display-4 fw-bold mb-0 text-dark">Loan Portfolio</h1>
                <p className="text-muted mb-0">Comprehensive overview of your loan accounts</p>
              </div>
            </div>
          </div>
        </div>

        {/* Date Filter Section */}
        <div className="row mb-4 fade-in">
          <div className="col-12">
            <div className="card stat-card">
              <div className="card-body">
                <h5 className="card-title mb-3">
                  <i className="fa fa-calendar main-theme-text me-2" style={{marginRight:"8px"}}></i>
                  Calculation Date Filter
                </h5>
                <div className="row align-items-end g-3">
                  <div className="col-md-3">
                    <label className="form-label fw-medium text-muted">
                      Select Calculation Date (up to today)
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      value={tempDate}
                      onChange={(e) => setTempDate(e.target.value)}
                      disabled={loading}
                    />
                  </div>
                  <div className="col-md-2" >
                    <div style={{display:'flex',gap:'10px'}}>
                    <button 
                    style={{marginTop:'22px',padding:'10px'}}
                      className="btn main-theme-bg text-white w-100"
                      onClick={handleApplyFilter}
                      disabled={loading || !tempDate}
                    >
                      <i className="fa fa-check me-2"></i>Apply
                    </button>
                    <button 
                    style={{marginTop:'22px',border:'1px solid #eee'}}
                      className="btn btn-outline-secondary w-100"
                      onClick={clearFilters}
                      disabled={loading}
                    >
                      <i className="fa fa-times me-2"></i>Reset
                    </button>
                    </div>
                  </div>
                 
                  <div className="col-md-7">
                    <div className="text-muted" style={{textAlign:'end',marginTop:'24px'}}>
                      <small>
                        <i className="fa fa-info-circle me-1"></i>
                        {loading ? 'Loading...' : `Showing data for ${convertInputDateToDDMMYYYY(selectedDate)}`}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Loan Cards */}
        <div className="row g-4 fade-in">
          {loading ? (
            <div className="col-12">
              <div className="card stat-card text-center py-5">
                <div className="card-body">
                  <div className="spinner-border main-theme-text mb-3" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <h4 className="text-muted">Loading loan data...</h4>
                  <p className="text-muted mb-0">Please wait while we fetch your loan information.</p>
                </div>
              </div>
            </div>
          ) : error ? (
            <div className="col-12">
              <div className="card stat-card text-center py-5 border-danger">
                <div className="card-body">
                  <i className="fa fa-exclamation-triangle fa-3x text-danger mb-3"></i>
                  <h4 className="text-danger">Error Loading Data</h4>
                  <button className="btn main-theme-bg text-white" onClick={() => handleApplyFilter()}>
                    <i className="fa fa-refresh me-2"></i>&nbsp;Retry Loading
                  </button>
                </div>
              </div>
            </div>
          ) : allData.length > 0 ? (
            <div className="container-fluid py-4 px-3 px-md-5">
       

        {/* Stats Overview */}
        <div className="row mb-5 g-4 fade-in" style={{marginTop:'10px'}}>
          <div className="col-lg-3 col-md-6">
            <div className="card stat-card h-100">
              <div className="card-body " style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                <div className="flex-grow-1">
                  <h6 className="card-subtitle mb-2 text-muted">Total Loans</h6>
                  <h2 className="card-title fw-bold text-dark mb-0">{allData.length}</h2>
                </div>
                <div className="icon-circle main-theme-bg text-white">
                  <i className="fa fa-credit-card"></i>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6">
            <div className="card stat-card h-100">
              <div className="card-body " style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                <div className="flex-grow-1">
                  <h6 className="card-subtitle mb-2 text-muted">Total Principal</h6>
                  <h2 className="card-title fw-bold text-dark mb-0">
                    {formatCurrency(allData.reduce((sum, loan) => sum + parseFloat(loan.princpleAmt), 0))}
                  </h2>
                </div>
                <div className="icon-circle bg-success text-white">
                  <i className="fa fa-money"></i>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6">
            <div className="card stat-card h-100">
              <div className="card-body " style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                <div className="flex-grow-1">
                  <h6 className="card-subtitle mb-2 text-muted">Total Payable</h6>
                  <h2 className="card-title fw-bold text-dark mb-0">
                    {formatCurrency(allData.reduce((sum, loan) => sum + parseFloat(loan.totalPayableAmount), 0))}
                  </h2>
                </div>
                <div className="icon-circle bg-primary text-white">
                  <i className="fa fa-line-chart"></i>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-6">
            <div className="card stat-card h-100">
              <div className="card-body " style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                <div className="flex-grow-1">
                  <h6 className="card-subtitle mb-2 text-muted">Avg Interest Rate</h6>
                  <h2 className="card-title fw-bold text-dark mb-0">
                    {(allData.reduce((sum, loan) => sum + parseFloat(loan.annualInterestRate), 0) / allData.length).toFixed(2)}%
                  </h2>
                </div>
                <div className="icon-circle bg-info text-white">
                  <i className="fa fa-percent"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Loan Cards */}
        <div className="row g-4 fade-in">
          {allData.map((loan, index) => (
            <div key={loan.loanId || index} className="col-12 col-xl-12">
              <div className="card card-custom">
                {/* Card Header */}
                <div className="loan-header" style={{padding:'16px'}}>
                  <div className="row " style={{alignItems:'center',display:'flex'}}>
                    <div className="col-xs-6">
                      <div className="" style={{alignItems:'center',display:'flex'}}>
                        <div className="icon-circle bg-white main-theme-text me-3">
                          <i className="fa fa-credit-card"></i>
                        </div>
                        <div>
                          <h4 className="mb-1 fw-bold">Loan #{index + 1}</h4>
                          <small className="opacity-75">ID: {loan.loanId?.slice(-8) || 'N/A'}</small>
                        </div>
                      </div>
                    </div>
                    <div className="col-xs-6">
                      <div className="" style={{display:'flex',flexDirection:'column',gap:'8px',borderRadius:'4px',justifyContent:'end',textAlign:'end'}}>
                        <span className={getStatusBadgeClass(loan.STATUS)} style={{color:'orange',display:'inline-block',width:'fit-content',marginLeft:'auto',borderRadius:'4px',padding:'4px'}}>
                          <i className={getStatusIcon(loan.STATUS)}></i> {loan.STATUS}
                        </span>
                        <span className={getStatusBadgeClass(loan.loanStatus)} style={{color:'orange',display:'inline-block',width:'fit-content',marginLeft:'auto',borderRadius:'4px',padding:'4px'}}>
                          <i className="fa fa-info-circle"></i> {loan.loanStatus}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card-body p-4">
                  {/* Amount Section */}
                  <div className="amount-sectionmb-4" style={{padding:'16px'}}>
                    <div className="row text-center g-3">
                      <div className="col-6">
                        <h6 className="text-muted mb-2">Principal Amount</h6>
                        <h3 className="fw-bold main-theme-text mb-0">
                          {formatCurrency(loan.princpleAmt)}
                        </h3>
                      </div>
                      <div className="col-6">
                        <h6 className="text-muted mb-2">Total Payable</h6>
                        <h3 className="fw-bold text-dark mb-0">
                          {formatCurrency(loan.totalPayableAmount)}
                        </h3>
                      </div>
                    </div>
                    <hr className="my-3" />
                    <div className="" style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                      <span className="text-muted fw-medium">Interest Accrued</span>
                      <span className="h5 fw-bold text-danger mb-0">
                        {formatCurrency(loan.interestAccrued)}
                      </span>
                    </div>
                  </div>

                  {/* Details Grid */}
                  <div className="row g-3 mb-4">
                    <div className="col-sm-6 col-xs-12" style={{margin:'10px 0 10px 0'}}>
                      <div className="detail-card bg-primary bg-opacity-10 " style={{padding:'12px'}}>
                        <div className=" mb-2" style={{display:'flex',alignItems:'center',gap:'5px'}}>
                          <i className="fa fa-line-chart  me-2"></i>
                          <small className="fw-medium ">Interest Rate</small>
                        </div>
                        <h5 className="fw-bold  mb-1">{loan.annualInterestRate}% p.a.</h5>
                        <small className="">Daily: {loan.dailyInterestRate}%</small>
                      </div>
                    </div>

                    <div className="col-sm-6 col-xs-12" style={{margin:'10px 0 10px 0'}}>
                      <div className="detail-card bg-success bg-opacity-10 " style={{padding:'12px'}}>
                        <div className="d-flex align-items-center mb-2" style={{display:'flex',alignItems:'center',gap:'5px'}}>
                          <i className="fa fa-money text-success me-2"></i>
                          <small className="fw-medium text-success">Processing Fee</small>
                        </div>
                        <h5 className="fw-bold text-success mb-1">{formatCurrency(loan.processingFee)}</h5>
                        <small className="text-success">One-time fee</small>
                      </div>
                    </div>

                    <div className="col-sm-6 col-xs-12" style={{margin:'10px 0 10px 0'}}>
                      <div className="detail-card bg-warning bg-opacity-10 " style={{padding:'12px'}}>
                        <div className="d-flex align-items-center mb-2" style={{display:'flex',alignItems:'center',gap:'5px'}}>
                          <i className="fa fa-calendar text-warning me-2"></i>
                          <small className="fw-medium text-warning">Days Since</small>
                        </div>
                        <h5 className="fw-bold text-warning mb-1">{loan.daysSinceDisbursement}</h5>
                        <small className="text-warning">Disbursement</small>
                      </div>
                    </div>

                    <div className="col-sm-6 col-xs-12" style={{margin:'10px 0 10px 0'}}>
                      <div className="detail-card bg-info bg-opacity-10 " style={{padding:'12px'}}>
                        <div className="d-flex align-items-center mb-2" style={{display:'flex',alignItems:'center',gap:'5px'}}>
                          <i className="fa fa-calculator text-info me-2"></i>
                          <small className="fw-medium text-info">Daily Accrual</small>
                        </div>
                        <h5 className="fw-bold text-info mb-1">{formatCurrency(loan.dailyInterestAccrual)}</h5>
                        <small className="text-info">Per day</small>
                      </div>
                    </div>
                  </div>

                  {/* Payment Info */}
                  <div className="alert alert-light border-start border-4 main-theme-bg mb-4">
                    <div className="d-flex align-items-center">
                      <i className="fa fa-info-circle main-theme-text me-3 fs-4"></i>
                      <div>
                        <h6 className="alert-heading mb-1 text-white">Payment Information</h6>
                        <p className="mb-2 text-white">{loan.paymentMessage}</p>
                        <small className="text-white">
                          <i className="fa fa-calendar me-1"></i>
                          Payment Date: {loan.PAYDATE} | 
                          <i className="fa fa-calculator ms-2 me-1"></i>
                          Calculation Date: {loan.calculationDate}
                        </small>
                      </div>
                    </div>
                  </div>

                  {/* Progress Bar */}
                  <div className="" style={{marginBottom:'12px'}}>
                    <div className="d-flex justify-content-between align-items-center mb-2" style={{display:'flex',justifyContent:'space-between',alignItems:
                        "center"
                    }}>
                      <span className="text-muted small">Interest Progress</span>
                      <span className="text-muted small">
                        {((parseFloat(loan.interestAccrued) / parseFloat(loan.totalPayableAmount)) * 100).toFixed(1)}%
                      </span>
                    </div>
                    <div className="progress progress-custom">
                      <div 
                        className="progress-bar main-theme-bg" 
                        style={{
                          width: `${((parseFloat(loan.interestAccrued) / parseFloat(loan.totalPayableAmount)) * 100)}%`
                        }}
                      ></div>
                    </div>
                  </div>

                 
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
          ) : (
            <div className="col-12">
              <div className="card stat-card text-center py-5">
                <div className="card-body">
                  <i className="fa fa-search fa-3x text-muted mb-3"></i>
                  <h4 className="text-muted">No loan data found</h4>
                  <p className="text-muted mb-3">
                    No loan data available for the selected calculation date. Try selecting a different date.
                  </p>
                  <button className="btn main-theme-bg text-white" onClick={clearFilters}>
                    <i className="fa fa-calendar me-2"></i>Reset to Today
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default LoanPortfolio;

